import olMap from 'ol/Map.js';
import { transform } from 'ol/proj';
import { transformExtent } from 'ol/proj';
import View from 'ol/View';
import ScaleBar from 'ol/control/ScaleLine';

const createOlMap = (options, geoProjection, mapProjection) => {
  const view = new View({
    center: transform(options.center, geoProjection, mapProjection),
    zoom: options.zoom,
    rotation: options.rotation,
    minZoom: options.minZoom,
    maxZoom: options.maxZoom
  })
  return new olMap({
    controls: [new ScaleBar({units:'us'})],
    layers: options.layers || [],
    target: options.target,
    view: view,
    loadTilesWhileAnimating: false,
    loadTilesWhileInteracting: false
  })
}

export { createOlMap, transform, transformExtent };